import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ArrowRight } from "lucide-react";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSignup: () => void;
}

const FreeLimitModal = ({ open, onOpenChange, onSignup }: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-black border border-cyan-400/20 text-white">
        <div className="space-y-4 py-2">
          <h2 className="text-xl font-semibold tracking-tight">
            Create your free account to see what to say next.
          </h2>
          <p className="text-sm text-white/65 leading-relaxed">
            You've seen what they did. The calibrated reply — soft, firm, or grey rock — is one
            click away. No password required. 3 credits included, and your first response is one
            of them.
          </p>
          <div className="flex flex-col sm:flex-row gap-2 pt-2">
            <button
              onClick={onSignup}
              className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-lg bg-cyan-500 hover:bg-cyan-400 text-black text-sm font-semibold flex-1 transition-all shadow-[0_0_30px_-6px_rgba(34,211,238,0.85)]"
            >
              Create Free Account
              <ArrowRight className="w-4 h-4" />
            </button>
            <button
              onClick={() => onOpenChange(false)}
              className="inline-flex items-center justify-center h-11 px-5 rounded-lg border border-white/10 text-white/70 hover:bg-white/5 text-sm transition-colors"
            >
              Maybe later
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FreeLimitModal;
